import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowLeft, ArrowRight, Check, ChevronDown, Search } from 'lucide-react';
import '../../components/landing/arc/arc.css';

const API = process.env.REACT_APP_BACKEND_URL;

const COUNTRIES = [
  { iso: 'US', name: 'United States', dial: '1', flag: '🇺🇸' },
  { iso: 'CA', name: 'Canada', dial: '1', flag: '🇨🇦' },
  { iso: 'GB', name: 'United Kingdom', dial: '44', flag: '🇬🇧' },
  { iso: 'AU', name: 'Australia', dial: '61', flag: '🇦🇺' },
  { iso: 'NZ', name: 'New Zealand', dial: '64', flag: '🇳🇿' },
  { iso: 'IE', name: 'Ireland', dial: '353', flag: '🇮🇪' },
  { iso: 'DE', name: 'Germany', dial: '49', flag: '🇩🇪' },
  { iso: 'FR', name: 'France', dial: '33', flag: '🇫🇷' },
  { iso: 'ES', name: 'Spain', dial: '34', flag: '🇪🇸' },
  { iso: 'IT', name: 'Italy', dial: '39', flag: '🇮🇹' },
  { iso: 'PT', name: 'Portugal', dial: '351', flag: '🇵🇹' },
  { iso: 'NL', name: 'Netherlands', dial: '31', flag: '🇳🇱' },
  { iso: 'BE', name: 'Belgium', dial: '32', flag: '🇧🇪' },
  { iso: 'CH', name: 'Switzerland', dial: '41', flag: '🇨🇭' },
  { iso: 'AT', name: 'Austria', dial: '43', flag: '🇦🇹' },
  { iso: 'SE', name: 'Sweden', dial: '46', flag: '🇸🇪' },
  { iso: 'NO', name: 'Norway', dial: '47', flag: '🇳🇴' },
  { iso: 'DK', name: 'Denmark', dial: '45', flag: '🇩🇰' },
  { iso: 'FI', name: 'Finland', dial: '358', flag: '🇫🇮' },
  { iso: 'PL', name: 'Poland', dial: '48', flag: '🇵🇱' },
  { iso: 'CZ', name: 'Czechia', dial: '420', flag: '🇨🇿' },
  { iso: 'GR', name: 'Greece', dial: '30', flag: '🇬🇷' },
  { iso: 'RO', name: 'Romania', dial: '40', flag: '🇷🇴' },
  { iso: 'HU', name: 'Hungary', dial: '36', flag: '🇭🇺' },
  { iso: 'BG', name: 'Bulgaria', dial: '359', flag: '🇧🇬' },
  { iso: 'HR', name: 'Croatia', dial: '385', flag: '🇭🇷' },
  { iso: 'RS', name: 'Serbia', dial: '381', flag: '🇷🇸' },
  { iso: 'UA', name: 'Ukraine', dial: '380', flag: '🇺🇦' },
  { iso: 'TR', name: 'Turkey', dial: '90', flag: '🇹🇷' },
  { iso: 'IL', name: 'Israel', dial: '972', flag: '🇮🇱' },
  { iso: 'AE', name: 'United Arab Emirates', dial: '971', flag: '🇦🇪' },
  { iso: 'SA', name: 'Saudi Arabia', dial: '966', flag: '🇸🇦' },
  { iso: 'QA', name: 'Qatar', dial: '974', flag: '🇶🇦' },
  { iso: 'KW', name: 'Kuwait', dial: '965', flag: '🇰🇼' },
  { iso: 'IN', name: 'India', dial: '91', flag: '🇮🇳' },
  { iso: 'PK', name: 'Pakistan', dial: '92', flag: '🇵🇰' },
  { iso: 'BD', name: 'Bangladesh', dial: '880', flag: '🇧🇩' },
  { iso: 'LK', name: 'Sri Lanka', dial: '94', flag: '🇱🇰' },
  { iso: 'NP', name: 'Nepal', dial: '977', flag: '🇳🇵' },
  { iso: 'SG', name: 'Singapore', dial: '65', flag: '🇸🇬' },
  { iso: 'MY', name: 'Malaysia', dial: '60', flag: '🇲🇾' },
  { iso: 'ID', name: 'Indonesia', dial: '62', flag: '🇮🇩' },
  { iso: 'TH', name: 'Thailand', dial: '66', flag: '🇹🇭' },
  { iso: 'VN', name: 'Vietnam', dial: '84', flag: '🇻🇳' },
  { iso: 'PH', name: 'Philippines', dial: '63', flag: '🇵🇭' },
  { iso: 'JP', name: 'Japan', dial: '81', flag: '🇯🇵' },
  { iso: 'KR', name: 'South Korea', dial: '82', flag: '🇰🇷' },
  { iso: 'CN', name: 'China', dial: '86', flag: '🇨🇳' },
  { iso: 'HK', name: 'Hong Kong', dial: '852', flag: '🇭🇰' },
  { iso: 'TW', name: 'Taiwan', dial: '886', flag: '🇹🇼' },
  { iso: 'MX', name: 'Mexico', dial: '52', flag: '🇲🇽' },
  { iso: 'BR', name: 'Brazil', dial: '55', flag: '🇧🇷' },
  { iso: 'AR', name: 'Argentina', dial: '54', flag: '🇦🇷' },
  { iso: 'CL', name: 'Chile', dial: '56', flag: '🇨🇱' },
  { iso: 'CO', name: 'Colombia', dial: '57', flag: '🇨🇴' },
  { iso: 'PE', name: 'Peru', dial: '51', flag: '🇵🇪' },
  { iso: 'CR', name: 'Costa Rica', dial: '506', flag: '🇨🇷' },
  { iso: 'PA', name: 'Panama', dial: '507', flag: '🇵🇦' },
  { iso: 'DO', name: 'Dominican Republic', dial: '1', flag: '🇩🇴' },
  { iso: 'JM', name: 'Jamaica', dial: '1', flag: '🇯🇲' },
  { iso: 'ZA', name: 'South Africa', dial: '27', flag: '🇿🇦' },
  { iso: 'NG', name: 'Nigeria', dial: '234', flag: '🇳🇬' },
  { iso: 'KE', name: 'Kenya', dial: '254', flag: '🇰🇪' },
  { iso: 'GH', name: 'Ghana', dial: '233', flag: '🇬🇭' },
  { iso: 'EG', name: 'Egypt', dial: '20', flag: '🇪🇬' },
  { iso: 'MA', name: 'Morocco', dial: '212', flag: '🇲🇦' },
];

let _detected;
async function detectCountry() {
  if (_detected !== undefined) return _detected;
  let iso = '';
  try {
    const r = await fetch('https://ipapi.co/country/', { signal: AbortSignal.timeout(3500) });
    if (r.ok) iso = (await r.text()).trim().toUpperCase();
  } catch (e) { /* blocked or offline — fall through to locale */ }
  if (!/^[A-Z]{2}$/.test(iso)) {
    const m = (navigator.language || '').match(/-([A-Za-z]{2})$/);
    iso = m ? m[1].toUpperCase() : '';
  }
  _detected = COUNTRIES.find((c) => c.iso === iso) || null;
  return _detected;
}

const formatPhone = (val, country) => {
  const max = country.dial === '1' ? 10 : 12;
  const d = val.replace(/\D/g, '').slice(0, max);
  if (country.dial === '1') {
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }
  return d.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
};

function CountryPhoneField({ country, setCountry, phone, setPhone, inputCls }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  const q = query.trim().toLowerCase();
  const list = q ? COUNTRIES.filter((c) => c.name.toLowerCase().includes(q) || `+${c.dial}`.startsWith(q.replace(/^\+?/, '+')) || c.dial.startsWith(q)) : COUNTRIES;

  return (
    <div className="relative flex gap-2.5" ref={ref}>
      <button
        type="button"
        onClick={() => { setOpen((v) => !v); setQuery(''); }}
        className="arc-body shrink-0 flex items-center gap-1.5 px-4 py-4 rounded-2xl bg-white border border-black/[0.1] hover:border-[#141414]/40 focus:border-[#141414]/50 focus:outline-none transition-colors"
        data-testid="quiz-country-picker"
      >
        <span className="text-lg leading-none">{country.flag}</span>
        <span className="text-sm font-bold text-[#141414]">+{country.dial}</span>
        <ChevronDown size={14} className={`text-[#141414]/40 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      <input
        type="tel"
        required
        placeholder={country.dial === '1' ? '(555) 123-4567' : 'Phone number'}
        value={phone}
        onChange={(e) => setPhone(formatPhone(e.target.value, country))}
        className={inputCls}
        data-testid="quiz-phone-input"
      />
      {open && (
        <div className="absolute z-30 top-full left-0 mt-2 w-80 max-w-full rounded-2xl bg-white border border-black/[0.08] shadow-[0_16px_48px_rgba(20,20,20,0.16)] overflow-hidden" data-testid="quiz-country-dropdown">
          <div className="flex items-center gap-2 px-4 py-3 border-b border-black/[0.06]">
            <Search size={14} className="text-[#141414]/35 shrink-0" />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search country…"
              className="arc-body w-full text-sm font-medium text-[#141414] placeholder-[#141414]/35 focus:outline-none"
              data-testid="quiz-country-search"
            />
          </div>
          <div className="max-h-56 overflow-y-auto py-1">
            {list.map((c) => (
              <button
                key={c.iso}
                type="button"
                onClick={() => { setCountry(c); setPhone((p) => formatPhone(p, c)); setOpen(false); }}
                className={`arc-body w-full flex items-center gap-2.5 px-4 py-2.5 text-left hover:bg-black/[0.04] transition-colors ${c.iso === country.iso ? 'bg-black/[0.04]' : ''}`}
                data-testid={`quiz-country-option-${c.iso}`}
              >
                <span className="text-lg leading-none shrink-0">{c.flag}</span>
                <span className="flex-1 text-sm font-semibold text-[#141414] truncate">{c.name}</span>
                <span className="text-sm font-medium text-[#141414]/45 shrink-0">+{c.dial}</span>
              </button>
            ))}
            {list.length === 0 && <p className="arc-body text-sm text-[#141414]/40 px-4 py-3">No matches</p>}
          </div>
        </div>
      )}
    </div>
  );
}

const QUESTIONS = [
  {
    q: 'What best describes you right now?',
    options: ['Agency owner scaling up', 'Freelancer or consultant', '9–5 — building a side income', 'Just exploring AI'],
  },
  {
    q: 'Have you ever sold AI or automation services?',
    options: ['Yes — actively selling', 'Tried, but no consistent clients', 'Not yet — ready to start', 'Completely new to AI agents'],
  },
  {
    q: "What's your monthly income goal with AI agents?",
    options: ['$2K–$5K / month', '$5K–$10K / month', '$10K–$20K / month', '$20K+ / month'],
  },
];

const TOTAL_STEPS = QUESTIONS.length + 1;

export default function ChallengeQuiz({ open, onClose }) {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const [form, setForm] = useState({ name: '', email: '', phone: '' });
  const [country, setCountry] = useState(COUNTRIES[0]);
  const userPickedRef = useRef(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    detectCountry().then((c) => {
      if (c && !userPickedRef.current) setCountry(c);
    });
  }, [open]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { setStep(0); setAnswers({}); }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  const pick = (option) => {
    setAnswers({ ...answers, [step]: option });
    setTimeout(() => setStep((s) => s + 1), 260);
  };

  const submit = async (e) => {
    e.preventDefault();
    const digits = form.phone.replace(/\D/g, '');
    if (digits.length < 7) {
      toast.error('Please enter a valid phone number');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        name: form.name,
        email: form.email,
        phone: `+${country.dial} ${form.phone}`.trim(),
        country: country.name,
        country_code: country.iso,
        answers: QUESTIONS.map((question, i) => ({ q: question.q, a: answers[i] || '' })),
      };
      const r = await axios.post(`${API}/api/funnel/register`, payload);
      navigate(`/challenge/kit?reg=${r.data.reg_id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Registration failed — try again');
      setLoading(false);
    }
  };

  const progress = ((step + 1) / TOTAL_STEPS) * 100;
  const isContact = step >= QUESTIONS.length;

  const inputCls = 'arc-body w-full px-5 py-4 rounded-2xl bg-white border border-black/[0.1] text-[#141414] font-medium placeholder-[#141414]/35 focus:border-[#141414]/50 focus:outline-none transition-colors';

  return (
    <div className="fixed inset-0 z-[100] arc-bone overflow-y-auto" data-testid="challenge-quiz-overlay">
      {/* top bar */}
      <div className="sticky top-0 arc-bone z-10">
        <div className="h-1.5 bg-black/[0.06]">
          <div className="h-full bg-[#141414] transition-all duration-500 ease-out" style={{ width: `${progress}%` }} data-testid="quiz-progress-bar" />
        </div>
        <div className="max-w-xl mx-auto flex items-center justify-between px-6 py-4">
          {step > 0 ? (
            <button onClick={() => setStep(step - 1)} className="flex items-center gap-1.5 arc-body text-sm font-bold text-[#141414]/50 hover:text-[#141414] transition-colors" data-testid="quiz-back-btn">
              <ArrowLeft size={15} /> Back
            </button>
          ) : <span />}
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-black/[0.05] hover:bg-black/[0.1] flex items-center justify-center transition-colors" data-testid="quiz-close-btn">
            <X size={16} className="text-[#141414]" />
          </button>
        </div>
      </div>

      <div className="max-w-xl mx-auto px-6 pt-6 pb-20">
        <AnimatePresence mode="wait">
          {!isContact ? (
            <motion.div key={step} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }} transition={{ duration: 0.25 }}>
              <p className="arc-body text-xs font-bold uppercase tracking-[0.25em] text-[#141414]/40 mb-4">Question {step + 1} of {QUESTIONS.length}</p>
              <h2 className="arc-head font-black text-[#141414] text-2xl sm:text-3xl leading-tight mb-8" data-testid="quiz-question">{QUESTIONS[step].q}</h2>
              <div className="space-y-3">
                {QUESTIONS[step].options.map((option, i) => {
                  const selected = answers[step] === option;
                  return (
                    <button
                      key={option}
                      onClick={() => pick(option)}
                      className={`w-full text-left flex items-center justify-between gap-4 rounded-2xl border-2 bg-white px-5 py-4.5 p-5 transition-all duration-150 ${selected ? 'border-[#141414] shadow-[0_6px_24px_rgba(20,20,20,0.1)]' : 'border-transparent shadow-[0_2px_12px_rgba(20,20,20,0.05)] hover:border-[#141414]/30'}`}
                      data-testid={`quiz-option-${i}`}
                    >
                      <span className="arc-body text-base font-bold text-[#141414]">{option}</span>
                      <span className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selected ? 'bg-[#141414] border-[#141414]' : 'border-black/15'}`}>
                        {selected && <Check size={13} className="text-[#F0EFEC]" />}
                      </span>
                    </button>
                  );
                })}
              </div>
            </motion.div>
          ) : (
            <motion.div key="contact" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }} transition={{ duration: 0.25 }}>
              <p className="arc-body text-xs font-bold uppercase tracking-[0.25em] text-[#141414]/40 mb-4">Last step</p>
              <h2 className="arc-head font-black text-[#141414] text-2xl sm:text-3xl leading-tight mb-2">Where should we send your seat details?</h2>
              <p className="arc-body text-base text-[#141414]/55 mb-8">Your access link and event reminders hit your inbox instantly.</p>
              <form onSubmit={submit} className="space-y-3.5" data-testid="quiz-contact-form">
                <input type="text" required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} data-testid="quiz-name-input" />
                <input type="email" required placeholder="Best email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} data-testid="quiz-email-input" />
                <CountryPhoneField country={country} setCountry={(c) => { userPickedRef.current = true; setCountry(c); }} phone={form.phone} setPhone={(v) => setForm((f) => ({ ...f, phone: typeof v === 'function' ? v(f.phone) : v }))} inputCls={inputCls} />
                <button type="submit" disabled={loading} className="arc-body group w-full flex items-center justify-center gap-2 rounded-full bg-[#141414] text-[#F0EFEC] text-lg font-bold px-8 py-4.5 py-4 hover:bg-black disabled:opacity-50 transition-colors" data-testid="quiz-submit-btn">
                  {loading ? 'Saving your seat…' : 'Save my free seat'}
                  {!loading && <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />}
                </button>
                <p className="arc-body text-xs text-[#141414]/40 text-center pt-1">Free to attend · We never share your info</p>
              </form>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
